import { useAmc } from "../store/AmcContext";
import { useAuth } from "../store/AuthContext";
import { useTheme } from "next-themes";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { amcCode, loading: loadingAmcCode, error: amcCodeError } = useAmc();

  const { theme } = useTheme();

  if (loading || loadingAmcCode) {
    return (
      <div className='container-fluid p-0'>
        <div
          className='row w-100 mx-auto flex-column justify-content-center align-items-center gap-sm-2 flex-nowrap'
          style={{
            minHeight: "100dvh",
            overflow: "hidden",
            padding: "8px",
            background: "linear-gradient(90deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)",
            // background:
            //   theme === "dark"
            //     ? "linear-gradient(90deg, var(--theme-dark-primary) 0%, var(--theme-dark-secondary) 100%)"
            //     : "linear-gradient(90deg, var(--theme-light-primary) 0%, var(--theme-light-secondary) 100%)",
          }}
        >
          <div
            dir="ltr"
            className='col-auto p-0 p-4 rounded-4 d-flex flex-column row-gap-3 align-items-center justify-content-center'
            style={{
              backgroundColor: "rgba(255,255,255,.45)",
              boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
              minHeight: "200px",
              minWidth: "240px",
            }}
          >
            <div dir="ltr" className='loader'></div>
            <div dir="ltr" className='loader-text ps-2'></div>
          </div>
        </div>
      </div>
    );
  }

  if (amcCodeError) {
    return (
      <div className='container-fluid p-0'>
        <div
          className='row w-100 mx-auto flex-column justify-content-center align-items-center gap-sm-2 flex-nowrap'
          style={{
            minHeight: "100dvh",
            overflow: "hidden",
            padding: "8px",
            background: "linear-gradient(90deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)",
          }}
        >
          <div
            dir="ltr"
            className='col-auto p-0 p-4 rounded-4 d-flex flex-column row-gap-3 align-items-center justify-content-center'
            style={{
              backgroundColor: "rgba(255,255,255,.45)",
              boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
              minHeight: "200px",
              minWidth: "240px",
            }}
          >
            <svg  xmlns="http://www.w3.org/2000/svg"  width={68}  height={68}  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth={1.5}  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-square-x" style={{ color: 'rgb(172, 53, 64)' }}><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" /><path d="M9 9l6 6m0 -6l-6 6" /></svg>
            <div className="text-center mb" style={{
              color: '',
              fontSize: '22px',
              fontWeight: '500',
              letterSpacing: '.02em',
              lineHeight: '1.3'
            }}>
              CONNECTIVITY<br/>ISSUE
            </div>

            {/* <div className="text-center" style={{
              color: theme === 'dark' ? 'rgba(0,0,0,.6)' : '',
              fontSize: '18px',
              fontWeight: '500',
              letterSpacing: '.02em',
              lineHeight: '1.1'
            }}>
              Server not responding, try again later ...
            </div> */}
          </div>
        </div>
      </div>
    )
  }

  if (!user) {
    // return <Navigate to='/auth' state={{ from: location }} replace />
  }

  return <>{children}</>;
};

export default ProtectedRoute;
